export const validarCedula = (cedulaRUC) => {
  if (typeof(cedulaRUC) === 'string' && (cedulaRUC.length === 10 || cedulaRUC.length === 13) && /^\d+$/.test(cedulaRUC)) {
    if (cedulaRUC.length === 10) { // Validar cédula
      let digitos = cedulaRUC.split('').map(Number);
      let codigo_provincia = digitos[0] * 10 + digitos[1];
      if (codigo_provincia >= 1 && (codigo_provincia <= 24 || codigo_provincia === 30)) {
        let digito_verificador = digitos.pop();
        let digito_calculado = digitos.reduce(
          function(valorPrevio, valorActual, indice) {
            return valorPrevio - (valorActual * (2 - indice % 2)) % 9 - (valorActual === 9) * 9;
          }, 1000
        ) % 10;
        return digito_calculado === digito_verificador;
      }
    } else if (cedulaRUC.length === 13) { // Validar RUC
      let digitos = cedulaRUC.split('').map(Number);
      let codigo_provincia = digitos.slice(0, 2).join('');
      let tercer_digito = digitos.slice(2, 3).join('');
      let secuencia = digitos.slice(3, 10).join('');
      let ultimos_digitos = digitos.slice(10).join('');
      
      if (codigo_provincia >= 1 && (codigo_provincia <= 24 || codigo_provincia === 30)) {
        
        if (tercer_digito === '9' && ultimos_digitos === '001') {
          
          // Validar RUC empresa privada
          let coeficientes = [4, 3, 2, 7, 6, 5, 4, 3, 2];
          let suma = 0;
          for (let i = 0; i < coeficientes.length; i++) {
            suma += digitos[i] * coeficientes[i];
          }
          let residuo = suma % 11;
          let verificador_calculado = residuo === 0 ? 0 : 11 - residuo;
          let verificador_dado = parseInt(digitos[9]);
          return verificador_calculado === verificador_dado;

        } else if (tercer_digito === '6' && ultimos_digitos === '001') {
          // Validar RUC empresa publica
          let coeficientes = [3, 2, 7, 6, 5, 4, 3, 2];
          let suma = 0;
          for (let i = 0; i < coeficientes.length; i++) {
            suma += digitos[i] * coeficientes[i];
          }
          let residuo = suma % 11;
          let verificador_calculado = residuo === 0 ? 0 : 11 - residuo;
          
          //Expecion si residuo es 0
          if (verificador_calculado === 0) {
            verificador_calculado = 0
          }
          let verificador_dado = parseInt(digitos[8]);
          return verificador_calculado === verificador_dado;
        } else if (secuencia.length > 6 && ultimos_digitos === '001') {
          return true;
        }
      }
    }
  }
  return false;
};

export const validarEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
}

export const validarTelefono = (contact) => {
    //const regex = /^09\d{8}$/|/^(02|03|06|04|05|07\d{7})$/;
    const regex = /^09\d{8}$/;
    const regex1 = /^(02|03|06|04|05|07)\d{7}$/;
    return regex.test(contact) || regex1.test(contact);
}

export const validarNombre = (name) => {
  const regex = /^[a-zA-ZñÑ\s]+$/;
  return regex.test(name);
}